/**
 * Rechenschaftsberichte (annual accountability reports) — none published
 * yet. Add entries here once real reports exist; same shape as the
 * `documents` frontmatter field on spenden (see README "Content" section).
 * `file` is a path under `public/`, placed there manually.
 *
 * Example, once a real PDF exists:
 * { title: "Rechenschaftsbericht 2026", file: "/assets/ueber-uns/rechenschaftsbericht-2026.pdf", description: "..." }
 */
export const REPORTS = {
  de: [],
  en: [],
};
